import ConditionsSectionImplementation from '../implementation/sections/ConditionsSection';
import { ComponentProps } from '@components/strapi/DynamicZoneComponent';
import {
  StrapiConditionsSectionDTO,
  ConditionsSectionDTO,
} from '@lib/strapi/dtos/components/sections/conditionsSection.dto';

const ConditionsSection = (props: ComponentProps<ConditionsSectionDTO>) => {
  return <ConditionsSectionImplementation {...props}></ConditionsSectionImplementation>;
};

export default ConditionsSection;
